var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0026 9.16683C7.29427 9.16683 9.16927 7.29183 9.16927 5.00016C9.16927 2.7085 7.29427 0.833496 5.0026 0.833496C2.71094 0.833496 0.835938 2.7085 0.835938 5.00016C0.835938 7.29183 2.71094 9.16683 5.0026 9.16683Z",
    fill: "#F35838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.3335V5.41683",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.6665H5.00374",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.1fb3191c8522aa8828fa08c27be93a4a.svg";
export { ForwardRef as ReactComponent };